export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/stop-icon.svg?ad9bb391b8fa3c8ce16955edbb961d8f";